// extracted by mini-css-extract-plugin
module.exports = {"label":"check-box_label__2jrRO","point":"check-box_point__BgH2D","input":"check-box_input__1DTuV"};